import { Component, Input, inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { OrdersItemsDetailDTO } from 'src/app/admin-api';

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrl: './product-card.component.scss'
})
export class ProductCardComponent {
  @Input() item!: OrdersItemsDetailDTO;

  private messageService: MessageService = inject(MessageService);

  getProductImageUrl(): string | null {
    return this.item?.defaultImageURL || null;
  }

  hasProductImage(): boolean {
    return !!(this.item?.defaultImageURL && this.item.defaultImageURL.trim());
  }

  formatCurrency(value: number | undefined): string {
    if (value === undefined || value === null) {
      return 'R$ 0,00';
    }
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  }

  canCopyValue(value: string | number | undefined): boolean {
    if (!value) {
      return false;
    }
    const textValue = String(value);
    return !!textValue.trim();
  }

  async copyToClipboard(
    value: string | number | undefined,
    fieldName: string
  ): Promise<void> {
    const textValue = String(value);

    try {
      await navigator.clipboard.writeText(textValue.trim());
      this.messageService.add({
        severity: 'success',
        summary: 'Copiado!',
        detail: `${fieldName} copiado para a área de transferência.`
      });
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Não foi possível copiar o valor.'
      });
    }
  }
}
